import React, { Component } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from "react-select";
import axios from "axios";
import Cookies from "js-cookie";
import settings from "../../helpers/Settings";
import AddCompany from "./addCompany";
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon } from "@iconify/react";
import { IconButton } from '@mui/material';
import MoreOptions from "./MoreOptions";
import { FormControl} from '@mui/material';
import Spinner from "react-bootstrap/Spinner";
let { KayanURL } = settings;
class DepartmentManagment extends Component{
    constructor(props) {
        super(props);
        this.state = {
          addMsg:""
        };
      }
      componentDidMount = async (e) => {
      };
      HandleInputTextChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
          this.setState({addMsg:"",[name]: value });
      }
      handelAddDepartment = async (event) => {
          event.preventDefault();
          this.setState({
            responseReady: false,
            addDepartmentRequestSent: true,
          });
          const result = await axios.post(KayanURL + "api/KSA/RCM/admin/addNewDepartment", {
            departmentName: this.state.departmentName,
            companyId:this.props.companyId,
            apiToken: Cookies.get("RCM_KSA_Admin_Token"),
          });
      
          if (result) {
            let { data } = result;
            this.setState({ addDepartmentRequestSent: false, responseReady: true });
            if (data.success) {
              this.setState({ addDeptSuccess: true,addMsg:"Department Added successfully" });
            } else {
              this.setState({ addDeptSuccess: false, error: data.error });
            }
        }
      }
      
  render (){
    let {addDepartmentRequestSent,responseReady,error}=this.state;
    return (
      <>
      <div
        style={{
          textAlign: "center",
          padding: "15px",
        }}>
            <FormControl  sx={{ mb: 3 }} style={{width:"100%"}}>
                  <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                  inputProps={{ sx: { padding: "11px" } }} required 
                           onChange={this.HandleInputTextChange}
                           label="Department Name" variant="outlined" name="departmentName"  />
              </FormControl>
                 <Button variant="contained" style={{ backgroundColor:"rgb(61 65 68)",display:"block",
                     height: "35px", width: "15%",
                    textTransform:"capitalize",color:"white",margin:"auto" }}
                     onClick={(e) => this.handelAddDepartment(e)}

                      > Add
                     </Button>
                     {addDepartmentRequestSent && !responseReady ? (
                      <div style={{textAlign:"center",marginTop:"10px"}}>
                      <Spinner animation="border" variant="success"  />
                        </div>
                        ) : this.state.addDeptSuccess?(
                          <div style={{textAlign:"center"}}>
                        <h5 style={{ color: "green",
                        textAlign:"center",
                        marginTop:"20px",fontSize:"10px"}}>{this.state.addMsg}</h5>
                          </div>
                        ):responseReady && error ? (
                        <h5 style={{ color: "red" }}>{error}</h5>
                        ) : null}
           
        </div>
      </>
      
      );
      }
  
}
export default DepartmentManagment;
